/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SignatureType } from './SignatureType';
import {
    SignatureTypeFromJSON,
    SignatureTypeFromJSONTyped,
    SignatureTypeToJSON,
    SignatureTypeToJSONTyped,
} from './SignatureType';

/**
 * 
 * @export
 * @interface SigningLoginRequestDto
 */
export interface SigningLoginRequestDto {
    /**
     * User's Signius account password
     * @type {string}
     * @memberof SigningLoginRequestDto
     */
    password: string;
    /**
     * 
     * @type {SignatureType}
     * @memberof SigningLoginRequestDto
     */
    signatureType?: SignatureType;
}



/**
 * Check if a given object implements the SigningLoginRequestDto interface.
 */
export function instanceOfSigningLoginRequestDto(value: object): value is SigningLoginRequestDto {
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SigningLoginRequestDtoFromJSON(json: any): SigningLoginRequestDto {
    return SigningLoginRequestDtoFromJSONTyped(json, false);
}

export function SigningLoginRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigningLoginRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'signatureType': json['signatureType'] == null ? undefined : SignatureTypeFromJSON(json['signatureType']),
    };
}

export function SigningLoginRequestDtoToJSON(json: any): SigningLoginRequestDto {
    return SigningLoginRequestDtoToJSONTyped(json, false);
}

export function SigningLoginRequestDtoToJSONTyped(value?: SigningLoginRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'password': value['password'],
        'signatureType': SignatureTypeToJSON(value['signatureType']),
    };
}

